<template>
    <b-row>
        <b-col md="12">
            <component-header
                class="settings-page-header"
                title="Payment Gateways Configuration"
                :hasSearch="false"
                :hasReload="false"
                :hasCreate="false"
                :hasback="false"
            />
        </b-col>
        <b-col>
            <b-card>
                <b-row>
                    <b-col md="4" class="pb-0">
                        <b-form-group class="mb-0">
                            <b-form-checkbox
                                type="checkbox"
                                size="lg"
                                id="cash_On_Delivery"
                                v-model="cashOnDelivery"
                                @change="onClickCod"
                            >
                                <h4 class="m-0 font-weight-light">
                                    Cash on Delivery
                                </h4>
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col md="4" class="pb-0">
                        <b-form-group class="mb-0">
                            <b-form-checkbox
                                type="checkbox"
                                size="lg"
                                id="online_Payment"
                                v-model="onlinePayment"
                                @change="onClickOnline"
                            >
                                <h4 class="m-0 font-weight-light">Online</h4>
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="onlinePayment">
                    <b-col
                        md="4"
                        v-for="(gateway, index) in configuredGateway"
                        :key="index"
                        :class="{ 'pl-0': index === 0 }"
                    >
                        <configCard
                            :imgSrc="gateway.logo"
                            :name="gateway.name"
                            :detailsText="gateway.description"
                            @onClickSetting="checkSetting(gateway)"
                            :isActive="gateway.enabled"
                            :isConfigured="true"
                            @toogleSwitch="(val) => inputCheck(val, gateway)"
                        ></configCard>
                    </b-col>
                </b-row>
                <hr
                    v-if="onlinePayment && configuredGateway.length != 0"
                    class="card-footer"
                />
                <b-row v-if="onlinePayment">
                    <b-col
                        md="4"
                        v-for="(gateway, index) in unconfiguredGateway"
                        :key="index"
                        :class="{ 'pl-0': index === 0 }"
                    >
                        <configCard
                            :imgSrc="gateway.logo"
                            :name="gateway.name"
                            :detailsText="gateway.description"
                            @onClickSetting="checkSetting(gateway)"
                            :isActive="gateway.enabled"
                            :isConfigured="false"
                            :showSwitch="false"
                            @onClickConfigure="onClickConfigure(gateway)"
                        ></configCard>
                    </b-col>
                </b-row>
                <template>
                    <b-modal
                        hide-header
                        id="gateway-config"
                        size="md"
                        ref="payment-gateway-config"
                        centered
                        hide-footer
                    >
                        <h4 class="text-capitalize pb-3">
                            {{ gatewayInfo.name }}
                        </h4>
                        <b-row>
                            <b-col md="6" v-if="gatewayInfo.name == 'razorpay'">
                                <b-form-input
                                    maxlength="200"
                                    placeholder="Enter Key ID"
                                    v-model="merchantId"
                                ></b-form-input>
                            </b-col>
                            <b-col md="6" v-else>
                                <b-form-input
                                    maxlength="200"
                                    placeholder="Enter Merchant ID"
                                    v-model="merchantId"
                                ></b-form-input>
                            </b-col>
                            <b-col md="6">
                                <b-form-input
                                    maxlength="200"
                                    placeholder="Enter Secret Key"
                                    v-model="secretGatewayKey"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-checkbox
                                    type="checkbox"
                                    size="lg"
                                    id="default-gateway"
                                    v-model="makeDefault"
                                >
                                    <h4 class="m-0 font-weight-light">
                                        Make it Default
                                    </h4>
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-md-center">
                            <b-col md="4" class="cancel-btn-col">
                                <b-button
                                    variant="danger"
                                    block
                                    @click="hideModal"
                                    >Cancel</b-button
                                >
                            </b-col>
                            <b-col md="4">
                                <b-button
                                    variant="primary"
                                    block
                                    @click="onClickSaveConfig"
                                    >Save</b-button
                                >
                            </b-col>
                        </b-row>
                    </b-modal>
                </template>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import profile from "@/components/profile/profileCategory";
import configCard from "@/components/tenantConfig/configCard.vue";
import { mapGetters, mapState } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
export default {
    components: {
        profile,
        configCard,
        ComponentHeader,
    },
    data() {
        return {
            cashOnDelivery: false,
            onlinePayment: false,
            makeDefault: false,
            gatewayInfo: {},
            switchStatus: true,
            merchantId: "",
            secretGatewayKey: "",
            configuredGateway: [],
            unconfiguredGateway: [],
        };
    },
    computed: {
        ...mapState({
            paymentGatewayList: (state) => state.tenant.paymentGatewayList,
            configPaymentGateway: (state) =>
                state.tenant.paymentGatewayConfigure,
            configuredGatewayList: (state) => state.tenant.configuredGateway,
        }),
        ...mapGetters({
            payMethod: ["tenant/GetTenantPreferences"],
        }),
    },
    methods: {
        async inputCheck(val, gatewayData) {
            let arrData = this.configuredGatewayList.payments[gatewayData.key];
            let appKeyId = "";

            if (gatewayData.key == "razorpay") {
                appKeyId = "keyId";
            } else appKeyId = "appId";

            let payload = {
                tenantId: this.$currentUserData._id,
                data: {
                    payments: {
                        [gatewayData.key]: {
                            enabled: val,
                            isDefault: arrData.isDefault,
                            [appKeyId]: arrData[appKeyId],
                            secretKey: arrData.secretKey,
                        },
                    },
                },
            };
            await this.$store.dispatch(
                "tenant/getPaymentGatewayConfigure",
                payload,
            );
            await this.$store.dispatch(
                "tenant/getConfiguredGatewayList",
                this.$currentUserData._id,
            );
            this.configuredGateway = [];
            this.checkGatewayConfiguration();
        },
        checkGatewayConfiguration() {
            if (this.configuredGatewayList !== null) {
                let arrObj = Object.keys(this.configuredGatewayList.payments);
                this.paymentGatewayList.filter((configured) => {
                    arrObj.some((gateway) => {
                        if (configured.key == gateway) {
                            configured.enabled =
                                this.configuredGatewayList.payments[
                                    configured.key
                                ].enabled;
                            this.configuredGateway.push({
                                ...configured,
                                ...this.configuredGatewayList.payments[
                                    configured.key
                                ],
                            });
                        }
                    });
                });
            }
            this.unconfiguredGateway = this.paymentGatewayList.filter(
                (unconfigured) => {
                    return !this.configuredGateway.some(
                        (gateway) => unconfigured.key == gateway.key,
                    );
                },
            );
        },
        checkSetting(gateway) {
            this.gatewayInfo = gateway;
            this.$refs["payment-gateway-config"].show();
            if (gateway.key === "razorpay") {
                this.merchantId = gateway.keyId;
            } else {
                this.merchantId = gateway.appId;
            }
            this.secretGatewayKey = gateway.secretKey;
            this.makeDefault = gateway.isDefault;
        },
        onClickConfigure(gatewayData) {
            this.gatewayInfo = gatewayData;
            this.$refs["payment-gateway-config"].show();
        },
        hideModal() {
            this.$refs["payment-gateway-config"].hide();
        },
        async onClickSaveConfig() {
            let payload = {};
            let appKeyId = "";
            let gatewayChoosen = this.gatewayInfo?.name || "";
            if (gatewayChoosen == "razorpay") {
                appKeyId = "keyId";
            } else appKeyId = "appId";
            payload = {
                tenantId: this.$currentUserData._id,
                data: {
                    payments: {
                        [gatewayChoosen]: {
                            enabled: this.switchStatus,
                            isDefault: this.makeDefault,
                            [appKeyId]: this.merchantId,
                            secretKey: this.secretGatewayKey,
                        },
                    },
                },
            };
            if (this.merchantId && this.secretGatewayKey) {
                await this.$store
                    .dispatch("tenant/getPaymentGatewayConfigure", payload)
                    .then((result) => {
                        this.$swal({
                            title: "Success!",
                            text: "Payment Gateway Configured Successfully.",
                            type: "success",
                        }).then(async (result) => {
                            await this.$store.dispatch(
                                "tenant/getConfiguredGatewayList",
                                this.$currentUserData._id,
                            );
                            this.configuredGateway = [];
                            this.checkGatewayConfiguration();
                            this.hideModal();
                        });
                        ((this.merchantId = ""),
                            (this.secretGatewayKey = ""),
                            (this.makeDefault = false));
                    })
                    .catch((error) => {
                        this.$toasted.error(error.message);
                    });
            } else {
                this.$swal({
                    title: "Error!",
                    text: "All Fields Required!",
                    type: "error",
                });
            }
        },

        async onClickCod() {
            if (this.onlinePayment == true) {
                this.onlinePayment = false;
                this.cashOnDelivery = true;
            }
            let payload = {
                id: this.$currentUserData._id,
                paymentMode: {
                    paymentMethod: {
                        cod: true,
                        online: false,
                    },
                },
            };
            await this.$store.dispatch(
                "tenant/updateGatewayPreferencesTenant",
                payload,
            );
        },

        async onClickOnline() {
            if (this.cashOnDelivery == true) {
                this.cashOnDelivery = false;
                this.onlinePayment = true;
            }
            let payload = {
                id: this.$currentUserData._id,
                paymentMode: {
                    paymentMethod: {
                        cod: false,
                        online: true,
                    },
                },
            };
            await this.$store.dispatch(
                "tenant/updateGatewayPreferencesTenant",
                payload,
            );
        },
    },
    async mounted() {
        await this.$store.dispatch("tenant/getPaymentGatewayList");
        await this.$store.dispatch(
            "tenant/getConfiguredGatewayList",
            this.$currentUserData._id,
        );
        this.checkGatewayConfiguration();
        this.cashOnDelivery = this.payMethod?.paymentMethod?.cod;
        this.onlinePayment = this.payMethod?.paymentMethod?.online;
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    },
};
</script>
<style scoped>
.settings-page-header {
    margin-top: 0;
}

:deep(.settings-page-header .component-header-navbar) {
    padding-top: 0;
}

.language-button button {
    width: 160px;
    margin-bottom: 15px;
    margin-left: 15px;
    margin-right: 15px;
    font-size: 14px;
}
.card-body {
    padding: 15px;
}
.card-footer {
    border-top: 2px dashed #c8d1d7;
}
.pl-0 {
    padding-left: 0 !important;
}
@media (max-width: 768px) {
    .language-button button {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
    }
}
@media (max-width: 991px) {
    .cancel-btn-col {
        margin-bottom: 10px;
    }
}
</style>
